import React from 'react'
import banner from './banner.png';
import './../../App.css'


const Navbar = () =>{
    return(
        <div className ="container  banner">
            <div className="row">
                <div className="col-md-6">
                    <h2 className="banner-text">Get all the latest news  and highlights from TechNewsPlus for your pleasure!</h2>
                </div>
                <div className="col-md-6">
                    <img src={banner}  className ="banner-image" alt="banner"/>
                </div>
            </div>
        </div>
    )
}


export default Navbar